<template>
  <div class="resource-detail-skeleton">
    <div class="resource-detail-skeleton__body">
      <div class="resource-detail-skeleton__card">
        <el-skeleton animated>
          <template slot="template">
            <div class="resource-detail-skeleton__hero">
              <el-skeleton-item variant="image" class="resource-detail-skeleton__cover" />
              <div class="resource-detail-skeleton__info">
                <el-skeleton-item variant="h1" class="resource-detail-skeleton__title" />
                <div class="resource-detail-skeleton__meta">
                  <div v-for="col in 3" :key="col" class="resource-detail-skeleton__meta-col">
                    <el-skeleton-item v-for="row in 3" :key="row" variant="text" />
                  </div>
                </div>
                <div class="resource-detail-skeleton__abstract">
                  <el-skeleton-item variant="h3" style="width: 80px; margin-bottom: 12px" />
                  <el-skeleton-item variant="text" />
                  <el-skeleton-item variant="text" />
                  <el-skeleton-item variant="text" style="width: 92%" />
                </div>
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>

      <div class="resource-detail-skeleton__files">
        <el-skeleton animated>
          <template slot="template">
            <el-skeleton-item variant="h3" style="width: 96px; margin-bottom: 16px" />
            <el-skeleton-item variant="text" style="width: 120px; margin-bottom: 20px" />
            <div v-for="index in 4" :key="index" class="resource-detail-skeleton__file-row">
              <el-skeleton-item variant="text" style="width: 42%" />
              <el-skeleton-item variant="text" style="width: 12%" />
              <el-skeleton-item variant="text" style="width: 12%" />
              <el-skeleton-item variant="button" style="width: 72px; height: 32px" />
            </div>
          </template>
        </el-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourceDetailSkeleton'
}
</script>

<style lang="scss" scoped>
.resource-detail-skeleton {
  &__body {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: $spacing-xl $content-padding $spacing-4xl;
    display: flex;
    flex-direction: column;
    gap: $spacing-xl;
  }

  &__card,
  &__files {
    background: $color-white;
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba($color-brown-dark, 0.06);
    padding: $spacing-xl;
  }

  &__hero {
    display: flex;
    gap: $spacing-2xl;
    align-items: flex-start;
  }

  &__cover {
    width: 220px;
    height: 300px;
    flex-shrink: 0;
    border-radius: 6px;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__title {
    width: 48%;
    margin-bottom: $spacing-lg;
  }

  &__meta {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: $spacing-lg $spacing-xl;
    margin-bottom: $spacing-xl;
  }

  &__meta-col {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__abstract {
    padding-top: $spacing-lg;
    border-top: 1px solid rgba($color-border, 0.35);
  }

  &__file-row {
    display: grid;
    grid-template-columns: minmax(0, 1.8fr) 100px 100px 100px;
    gap: $spacing-base;
    align-items: center;
    padding: $spacing-md 0;
    border-bottom: 1px solid rgba($color-border, 0.2);

    &:last-child {
      border-bottom: none;
    }
  }
}

@media (max-width: 960px) {
  .resource-detail-skeleton {
    &__hero {
      flex-direction: column;
    }

    &__cover {
      width: 100%;
      max-width: 280px;
      margin: 0 auto;
    }

    &__meta {
      grid-template-columns: 1fr;
    }

    &__file-row {
      grid-template-columns: 1fr;
    }
  }
}
</style>
